import React from 'react'
import PropTypes from 'prop-types'
import Prism from 'prismjs'
import 'prismjs/components/prism-json'
import WithCopy from '../WithCopy';

const Code = (props) => {
  const { languages, code, space } = props
  const renderCode = () => {
    switch (languages) {
      case 'json':
        return Prism.highlight(
          JSON.stringify(code, null, space),
          Prism.languages[languages],
          languages
        )
      case 'text':
      default:
        return code
    }
  }

  return (
    <div className="copyable">
      <pre className={`language-${languages}`}>
        <code
          className={`language-${languages}`}
          dangerouslySetInnerHTML={{
            __html: renderCode(),
          }}
        />
      </pre>
      <WithCopy />
    </div>
  )
}

Code.defaultProps = {
  languages: 'text',
  code: '',
  space: 2,
}

Code.propTypes = {
  languages: PropTypes.string,
  code: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  space: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default Code
